import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import axios from 'axios';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
const EmpDetails = (props) => {
    const initialRoleFormData = {
        company: [],
        position: [],
        location: [],
        from_date: [],
        to_date: []
    };
    
    const [formData, setFormData] = useState(initialRoleFormData);
    const [rows, setRows] = useState([['', '', '', '', '', '']]);

    const addRow = () => {
        setRows([...rows, ['', '', '', '', '', '']]);
    };


    const deleteRow = (index) => {
        formData.splice(index, 1);
    };

    const handleChanged = (e, rowIndex,column_name) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState
        }));
        formData[column_name][rowIndex] = value;
        handleUpdatingValueAfterChanged(formData);
    };
    const handleDateChanged = (date, rowIndex,column_name) => {
        setFormData(prevState => ({
            ...prevState
        }));
        formData[column_name][rowIndex] = moment(date).format('DD-MM-YYYY');
        handleUpdatingValueAfterChanged(formData);
    };
    const handleUpdatingValueAfterChanged = (data)=>{
        props.onEmploymentDataChange(data);
    }

    return (
        <div>
                <div className="table-responsive poc-head rounded mt-2">
                    <table id="poctable_head" className="table table-bordered">
                        <thead className='text-center' >
                            <tr className="head">
                                <th>Sr</th>
                                <th>Company</th>
                                <th>Position</th>
                                <th>Location</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, rowIndex) => (
                                <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'alt' : ''}>
                                    <td>{rowIndex + 1}</td>
                                    <td><input class="form-control" name="company[]" placeholder="Company" onChange={(e) => handleChanged(e, rowIndex,'company')} value={formData['company'][rowIndex]}/>
                                        
                                    </td>
                                    <td><input class="form-control" name="position[]" placeholder="Position" onChange={(e) => handleChanged(e, rowIndex,'position')} value={formData['position'][rowIndex]}/>
                                        
                                    </td>
                                    <td><input class="form-control" name="location[]" placeholder="Location" onChange={(e) => handleChanged(e, rowIndex,'location')} value={formData['location'][rowIndex]}/>
                                        
                                    </td>
                                    <td>
                                        <ReactDatePicker showPopperArrow name="from_date[]" className='form-control' placeholderText='From Date' showIcon icon='fa fa-calendar' onChange={(date)=>{ handleDateChanged(date,rowIndex,'from_date')}}  value={formData['from_date'][rowIndex]}/>
                                    </td>
                                    <td> <ReactDatePicker showPopperArrow name="to_date[]" className='form-control' placeholderText='To Date' showIcon icon='fa fa-calendar' onChange={(date)=>{ handleDateChanged(date,rowIndex,'to_date')}} value={formData['to_date'][rowIndex]}/></td>
                                    <td>
                                        <i className="fa fa-trash-o poc_delectbtn" onClick={() => deleteRow(rowIndex)}></i>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <button type="button" onClick={addRow} className="custom-btn pull-right btn btn-sm btn-info"><i class="fa fa-plus"></i>&nbsp;Add</button>
        </div>


    )
}

export default EmpDetails;